import { createClient } from 'src/createClient.ts';
import { createDatabaseClient } from 'src/database/createDatabaseClient.ts';
import { setResolvers } from 'src/database/setResolvers.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { ApolloClient } from '@apollo/client/core';
import { CachedValue, DatabaseClient } from 'src/database/databaseClient.ts';

export const createDatabaseProviderState = async (
    cache: Map<string, CachedValue>,
    databaseCache: LocalForage,
    userSettings: UserSettings,
    uri: string,
    assetDomain: string,
): Promise<{ apollo: ApolloClient<unknown>; dbClient: DatabaseClient }> => {
    const apollo = createClient(`${uri}/graphql`);
    const dbClient = await createDatabaseClient(cache, databaseCache);
    setResolvers(
        apollo,
        dbClient,
        userSettings.currentRegion,
        userSettings.currentLocale,
        userSettings.shoppingCenter ?? '',
    );
    await dbClient.init(
        import.meta.env.MODE === 'development' ? '/node_modules/sql.js/dist/' : `${assetDomain}/assets/`,
    );
    return { apollo, dbClient };
};
